import { useStaffAuth } from '../store/useStaffAuth'

export type StoreRole = 'owner' | 'manager' | 'staff'

/**
 * #995 現在の店舗ロール。**スタッフセッションがあればその role**（manager/staff）、
 * なければ owner。同一端末をスタッフが交代で使う運用のため staff を優先し、owner に
 * 戻るには staff ログアウト or /store/login（どちらも staff セッションをクリアする）。
 */
export function useStoreRole(): StoreRole {
  const staffSession = useStaffAuth((s) => s.session)
  return staffSession ? staffSession.role : 'owner'
}
